import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledTextAreaWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const StyledTextAreaLabel = styled.span`
  ${setFontVariant('caption', colorsPalettes.carbon[250])};
`;

const getTextAreaStyles = (height = 120) => `
  max-width: 100%;
  height: ${height}px;
  margin: 4px 0;
  padding: 8px;
  border-radius: 3px;
  border: 1px solid ${colorsPalettes.carbon[50]};
  background-color: ${colorsPalettes.carbon[0]};
`;

export const StyledTextAreaLoader = styled.div<{ height?: number }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  ${({ height }) => getTextAreaStyles(height)};
`;

export const StyledTextArea = styled.textarea<{ height?: number }>`
  ${({ height }) => getTextAreaStyles(height)};
  outline: none;
  ${setFontVariant('body2', colorsPalettes.carbon[400])};

  ::placeholder {
    color: ${colorsPalettes.carbon[200]};
  }

  &:focus {
    border-color: ${colorsPalettes.blue[400]};
  }
`;
